import { UseFormReturn } from 'react-hook-form';
import { createFieldHelper, FlexFormFields } from '@cks-internal/react-base';
import { Flex } from '@chakra-ui/react';
import { useCustomProductRequestFormFields } from '../util/useCustomProductRequestFormFields.tsx';
import { CustomOrderItem } from '../../itemTypes.ts';
import { QuantityPicker } from '../../shoppingCart/components/QuantityPicker.tsx';

type Props = {
  formMethods: UseFormReturn<Partial<CustomOrderItem>>;
};

export const CustomProductRequestForm = (props: Props) => {
  const fieldHelper = createFieldHelper<Partial<CustomOrderItem>>(props.formMethods);
  const fields = useCustomProductRequestFormFields(props.formMethods, fieldHelper);
  const formGap = '8px';

  return (
    <Flex flexDir={'column'} gap={{ base: '8', lg: '16' }}>
      <Flex flexDir={'column'} gap={formGap}>
        <FlexFormFields formFields={fields} />
        <QuantityPicker
          max={99}
          min={1}
          value={props.formMethods.getValues('Quantity')}
          onChange={(value) =>
            props.formMethods.setValue('Quantity', value, {
              shouldValidate: true,
              shouldTouch: true,
              shouldDirty: true
            })
          }
        />
      </Flex>
    </Flex>
  );
};
